import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Order} from '../types';
import {
    useNavigate,
    useParams
} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<Order, 'id'>,
    handleSubmit: (values: Order) => void
}) => {
    const {id: customerId} = useParams();

    const navigate = useNavigate()

    const onSubmit = (values: Order) => {

        console.debug(values)

        handleSubmit(values);
        navigate(`/customers/${customerId}`);
    };

    const onCancel = () => {
        navigate(`/customers/${customerId}`);
    };


    let initialValues = {customerId: customerId} as Order;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
